const privacyPolicy = `1. **Az adatkezelési tájékoztató célja**

A Balaton Tánc Egyesület (8600 Siófok, Szépvölgyi út 2., a továbbiakban, szolgáltató, adatkezelő) mint adatkezelő, magára nézve kötelezőnek ismeri el jelen jogi közlemény tartalmát. Kötelezettséget vállal arra, hogy tevékenységével kapcsolatos minden adatkezelés megfelel a jelen szabályzatban és a hatályos nemzeti jogszabályokban, valamint az Európai Unió jogi aktusaiban meghatározott elvárásoknak.  

A Balaton Tánc Egyesület adatkezeléseivel kapcsolatosan felmerülő adatvédelmi irányelvek folyamatosan elérhetők a www.balatonte.hu/privacy-policy címen.

A Balaton Tánc Egyesület fenntartja magának a jogot jelen tájékoztató bármikori megváltoztatására. Természetesen az esetleges változásokról kellő időben értesíti közönségét. Amennyiben kérdése lenne jelen közleményünkhöz kapcsolódóan, kérjük, írja meg nekünk, és kollégánk megválaszolja kérdését.

A Balaton Tánc Egyesület elkötelezett ügyfelei és partnerei személyes adatainak védelmében, kiemelten fontosnak tartja ügyfelei információs önrendelkezési jogának tiszteletben tartását.

A Balaton Tánc Egyesület a személyes adatokat bizalmasan kezeli, és megtesz minden olyan biztonsági, technikai és szervezési intézkedést, mely az adatok biztonságát garantálja.

A Balaton Tánc Egyesület az alábbiakban ismerteti adatkezelési gyakorlatát.

2. **Az adatkezelő adatai**

Amennyiben megkeresné Cégünket, az info@balatonte.hu és +36-20-446-6534 elérhetőségeken léphet kapcsolatba az adatkezelővel.

A Balaton Tánc Egyesület minden hozzá beérkezett e-mailt a tárolt személyes adatokkal együtt az adatközléstől számított legfeljebb 1 év elteltével töröl.

Név: Balaton Tánc Egyesület
Székhely: 8600 Siófok, Szépvölgyi út 2.
Nyilvántartási szám: 14-02-0000570
Adószám: 19192716-1-14
Telefonszám: +36-20-446-6534
E-mail: info@balatonte.hu

2.1 Adatvédelmi tisztviselő

Név: Fejes Gergő
Email: gerfejes@gmail.com

3. **A kezelt személyes adatok köre**  
3.1 Regisztrációs során megadandó személyes adatok

A weboldalon regisztráció funkció nem található, személyes adatokat kizárólag a Kapcsolat menüponton keresztül elérhető űrlapnál kérünk el. Ezek az adatok a következők: Név, E-mail cím és Telefonszám. Ha a tárgy és az üzenet részben személyes adat kerül beküldésre, azt megfelelően rögzítjük és kezeljük. Az adatokat harmadik félnek nem továbbítjuk!

3.2 Technikai adatok

A Balaton Tánc Egyesület a személyes adatok kezeléséhez a szolgáltatás nyújtása során alkalmazott informatikai eszközöket úgy választja meg és üzemelteti, hogy a kezelt adat:

- az arra feljogosítottak számára hozzáférhető (rendelkezésre állás);
- hitelessége és hitelesítése biztosított (adatkezelés hitelessége);
- változatlansága igazolható (adatintegritás);
- a jogosulatlan hozzáférés ellen védett (adat bizalmassága) legyen.

A Balaton Tánc Egyesület az adatokat megfelelő intézkedésekkel védi a jogosulatlan hozzáférés, megváltoztatás, továbbítás, nyilvánosságra hozatal, törlés vagy megsemmisítés, valamint a véletlen megsemmisülés ellen.

A Balaton Tánc Egyesület olyan műszaki, szervezési és szervezeti intézkedésekkel gondoskodik az adatkezelés biztonságának védelméről, amely az adatkezeléssel kapcsolatban jelentkező kockázatoknak megfelelő védelmi szintet nyújt.

A Balaton Tánc Egyesület az adatkezelés során megőrzi:

- a titkosságot: megvédi az információt, hogy csak az férhessen hozzá, aki erre jogosult;
- a sértetlenséget: megvédi az információnak és a feldolgozás módszerének a pontosságát és teljességét;
- a rendelkezésre állást: gondoskodik arról, hogy amikor a jogosult használónak szüksége van rá, valóban hozzá tudjon férni a kívánt információhoz, és rendelkezésre álljanak az ezzel kapcsolatos eszközök.

3.3 Cookie-k (Sütik)
3.3.1 A sütik feladata

- információkat gyűjtenek a látogatókról és eszközeikről;
- megjegyzik a látogatók egyéni beállításait, amelyek felhasználásra kerül(het)nek pl. online tranzakciók igénybevételekor, így nem kell újra begépelni őket;
- megkönnyítik a weboldal használatát;
- minőségi felhasználói élményt biztosítanak.

A testre szabott kiszolgálás érdekében a felhasználó számítógépén kis adatcsomagot, ún. sütit (cookie) helyez el és a későbbi látogatás során olvas vissza. Ha a böngésző visszaküld egy korábban elmentett sütit, a sütit kezelő szolgáltatónak lehetősége van összekapcsolni a felhasználó aktuális látogatását a korábbiakkal, de kizárólag a saját tartalma tekintetében.

3.3.2 Feltétlenül szükséges, munkamenet (session) cookie-k

Ezen sütik célja, hogy a látogatók maradéktalanul és zökkenőmentesen böngészhessék a www.balatonte.hu weboldalt, használhassák annak funkcióit, és az ott elérhető szolgáltatásokat. Az ilyen típusú sütik érvényességi ideje a munkamenet (böngészés) befejezéséig tart, a böngésző bezárásával a sütik e fajtája automatikusan törlődik a számítógépről, illetve a böngészésre használt más eszközről.

3.3.3 Harmadik fél által elhelyezett cookie-k (analitika)

A www.balatonte.hu weboldalán alkalmazza a Google Analytics mint harmadik fél sütijeit is. A Google Analytics statisztikai célú szolgáltatás használatával a www.balatonte.hu információkat gyűjt azzal kapcsolatban, hogy a látogatók hogyan használják a weboldalt. Az adatot a honlap fejlesztésének és a felhasználói élmény javításának céljával használja fel. Ezen sütik szintén lejáratukig a látogató számítógépén vagy böngészésre használt más eszközén, annak böngészőjében maradnak, illetve amíg a látogató nem törli őket.

3.4 Online rendeléshez kapcsolódó adatok

A weboldalon nem valósul meg termék értékesítés, így ehhez kapcsolódó adatokat nem kérünk el. A www.balatonte.hu oldalon kizárólag a Kapcsolat menüponton keresztül elérhető űrlapnál kérünk el. Ezek az adatok a következők: Név, E-mail cím és Telefonszám. Ha a tárgy és az üzenet részben személyes adat kerül beküldésre, azt megfelelően rögzítjük és kezeljük.

3.5 Online ügyintézéshez kapcsolódó adatok

A www.balatonte.hu oldalon kizárólag a Kapcsolat menüponton keresztül elérhető űrlapnál kérünk el. Ezek az adatok a következők: Név, E-mail cím és Telefonszám. Ha a tárgy és az üzenet részben személyes adat kerül beküldésre, azt megfelelően rögzítjük és kezeljük.

3.6 Hírlevélhez kapcsolódó adatok

Jelenleg, a www.balatonte.hu weboldalon nincs hírlevél feliratkozási lehetőség, így ehhez kapcsolódó személyes adat sem kerül tárolásra.

4. **A kezelt adatok tervezett felhasználása és megőrzési ideje**
Adatkezelés neve		
    Kapcsolat

  Felhasználása
Kapcsolatfelvétel

       Jogalap	
Látogató hozzájárulása

Megőrzési idő
	1 év


5. **Az adatkezelés célja, módja és jogalapja**
5.1 Általános adatkezelési irányelvek

A Balaton Tánc Egyesület tevékenységének adatkezelései önkéntes hozzájáruláson, illetve törvényi felhatalmazáson alapulnak. Az önkéntes hozzájáruláson alapuló adatkezelések esetében az érintettek e hozzájárulásukat az adatkezelés bármely szakában visszavonhatják.

Bizonyos esetekben a megadott adatok egy körének kezelését, tárolását, továbbítását jogszabályok teszik kötelezővé, melyről külön értesítjük ügyfeleinket.

Felhívjuk a Balaton Tánc Egyesület részére adatközlők figyelmét, hogy amennyiben nem saját személyes adataikat adják meg, az adatközlő kötelessége az érintett hozzájárulásának beszerzése.

Adatkezelési alapelvei összhangban vannak az adatvédelemmel kapcsolatos hatályos jogszabályokkal, így különösen az alábbiakkal:

- 2011. évi CXII. törvény – az információs önrendelkezési jogról és az információ-szabadságról (Infotv.);
- Az Európai Parlament és a Tanács (EU) 2016/679 rendelete (2016. április 27.) – a természetes személyeknek a személyes adatok kezelése tekintetében tör-ténő védelméről és az ilyen adatok szabad áramlásáról, valamint a 95/46/EK rendelet hatályon kívül helyezéséről (általános adatvédelmi rendelet, GDPR);
- 2013. évi V. törvény – a Polgári Törvénykönyvről (Ptk.);
- 2000. évi C. törvény – a számvitelről (Számv. tv.);
- 2017. évi LIII. törvény – a pénzmosás és terrorizmus finanszírozása megelőzéséről és megakadályozásáról (Pmt.);
- 2013. évi CCXXXVII. törvény – a hitelintézetekről és a pénzügyi vállalkozások-ról (Hpt.).

6. **Az adatok fizikai tárolási helyei**
Személyes adatai (vagyis azok az adatok, amelyek az Ön személyével kapcsolatba hozhatók) a következő módon kerülhetnek a kezelésünkbe: egyfelől az internetes kapcsolat fenntartásával összefüggésben az Ön által használt számítógéppel, böngészőprogrammal, internetes címmel, a látogatott oldalakkal kapcsolatos technikai adatok automatikusan képződnek számítógépes rendszerünkben, másfelől Ön is megadhatja nevét, elérhetőségét vagy más adatait, ha a honlap használata során személyes kapcsolatba kíván lépni velünk.

A rendszer működtetése során technikailag rögzítésre kerülő adatok: az érintett bejelentkező számítógépének azon adatai, melyek a szavazás során generálódnak és melyeket a www.balatonte.hu rendszere a technikai folyamatok automatikus eredményeként rögzít. Az automatikusan rögzítésre kerülő adatot a rendszer az érintett külön nyilatkozata vagy cselekménye nélkül a belépéskor, illetve kilépéskor automatikusan naplózza. Ezen adat egyéb személyes felhasználói adatokkal – törvény által kötelezővé tett esetek kivételével – össze nem kapcsolható. Az adathoz kizárólag a www.balatonte.hu tulajdonosa fér hozzá.

7. **Adattovábbítás, adatfeldogozás, az adatokat megismerők köre**
A www.balatonte.hu weboldal Kapcsolat menüpontján keresztül beérkezett személyes adatok nem kerülnek továbbításra, ezeket az adatokat kizárólag az oldal tulajdonosa ismeri és kezeli kapcsolattartás/kapcsolatfelvétel céljából.

8. **Érintett jogai és jogérvényesítési lehetőségei**
Az érintett tájékoztatást kérhet személyes adatai kezeléséről, valamint kérheti személyes adatainak helyesbítését, illetve – a kötelező adatkezelések kivételével – törlését, visszavonását, élhet adathordozási-, és tiltakozási jogával az adat felvételénél jelzett módon, illetve az adatkezelő fenti elérhetőségein.

8.1 Tájékoztatáshoz való jog

A Balaton Tánc Egyesület megfelelő intézkedéseket hoz annak érdekében, hogy az érintettek részére a személyes adatok kezelésére vonatkozó, a GDPR 13. és a 14. cikkben említett valamennyi információt és a 15–22. és 34. cikk szerinti minden egyes tájékoztatást tömör, átlátható, érthető és könnyen hozzáférhető formában, világosan és közérthetően megfogalmazva nyújtsa.

8.2 Az érintett hozzáféréshez való joga

Az érintett jogosult arra, hogy az adatkezelőtől visszajelzést kapjon arra vonatkozóan, hogy személyes adatainak kezelése folyamatban van-e, és ha ilyen adatkezelés folyamatban van, jogosult arra, hogy a személyes adatokhoz és a következő információkhoz hozzáférést kapjon: az adatkezelés céljai; az érintett személyes adatok kategóriái; azon címzettek vagy címzettek kategóriái, akikkel, illetve amelyekkel a személyes adatokat közölték vagy közölni fogják, ideértve különösen a harmadik országbeli címzetteket, illetve a nemzetközi szervezeteket; a személyes adatok tárolásának tervezett időtartama; a helyesbítés, törlés vagy adatkezelés korlátozásának és a tiltakozás joga; a felügyeleti hatósághoz címzett panasz benyújtásának joga; az adatforrásokra vonatkozó információ; az automatizált döntéshozatal ténye, ideértve a profilalkotást is, valamint az alkalmazott logikára és arra vonatkozó érthető információk, hogy az ilyen adatkezelés milyen jelentőséggel bír, és az érintettre nézve milyen várható következményekkel jár. Az adatkezelő a kérelem benyújtásától számított legfeljebb egy hónapon belül adja meg a tájékoztatást.

8.3 Helyesbítés joga

Az érintett kérheti a Balaton Tánc Egyesület által kezelt, rá vonatkozó pontatlan személyes adatok helyesbítését és a hiányos adatok kiegészítését.

8.4 Törléshez való jog

Az érintett az alábbi indokok valamelyikének fennállása esetén jogosult arra, hogy kérésére a Balaton Tánc Egyesület indokolatlan késedelem nélkül törölje a rá vonatkozó személyes adatokat:

- személyes adatokra már nincs szükség abból a célból, amelyből azokat gyűjtötték vagy más módon kezelték;
- az érintett visszavonja az adatkezelés alapját képező hozzájárulását, és az adatkezelésnek nincs más jogalapja;
- az érintett tiltakozik az adatkezelés ellen, és nincs elsőbbséget élvező jogszerű ok az adatkezelésre;
- a személyes adatokat jogellenesen kezelték;
- a személyes adatokat az adatkezelőre alkalmazandó uniós vagy tagállami jogban előírt jogi kötelezettség teljesítéséhez törölni kell;
- a személyes adatok gyűjtésére információs társadalommal összefüggő szolgáltatások kínálásával kapcsolatosan került sor.

Az adatok törlése nem kezdeményezhető, ha az adatkezelés szükséges: a véleménynyilvánítás szabadságához és a tájékozódáshoz való jog gyakorlása céljából; a személyes adatok kezelését előíró, az adatkezelőre alkalmazandó uniós vagy tagállami jog szerinti kötelezettség teljesítése, illetve közérdekből vagy az adatkezelőre ruházott közhatalmi jogosítvány gyakorlása keretében végzett feladat végrehajtása céljából; a népegészség-ügy területét érintő, vagy archiválási, tudományos és történelmi kutatási célból vagy statisztikai célból, közérdek alapján; vagy jogi igények előterjesztéséhez, érvényesítéséhez, illetve védelméhez.

8.5 Az adatkezelés korlátozásához való jog

Az érintett kérésére a Balaton Tánc Egyesület korlátozza az adatkezelést, ha az alábbi feltételek valamelyike teljesül:

- az érintett vitatja a személyes adatok pontosságát, ez esetben a korlátozás arra az időtartamra vonatkozik, amely lehetővé teszi, a személyes adatok pontosságának ellenőrzését;
- az adatkezelés jogellenes, és az érintett ellenzi az adatok törlését, és ehelyett kéri azok felhasználásának korlátozását;
- az adatkezelőnek már nincs szüksége a személyes adatokra adatkezelés céljából, de az érintett igényli azokat jogi igények előterjesztéséhez, érvényesítéséhez vagy védelméhez; vagy
- az érintett tiltakozott az adatkezelés ellen; ez esetben a korlátozás arra az időtartamra vonatkozik, amíg megállapításra nem kerül, hogy az adatkezelő jogos indokai elsőbbséget élveznek-e az érintett jogos indokaival szemben.

Ha az adatkezelés korlátozás alá esik, a személyes adatokat a tárolás kivételével csak az érintett hozzájárulásával, vagy jogi igények előterjesztéséhez, érvényesítéséhez vagy védelméhez, vagy más természetes vagy jogi személy jogainak védelme érdekében, vagy az Unió, illetve valamely tagállam fontos közérdekéből lehet kezelni.

8.6 Adathordozáshoz való jog

Az érintett jogosult arra, hogy a rá vonatkozó, általa az adatkezelő rendelkezésére bocsátott személyes adatokat tagolt, széles körben használt, géppel olvasható formátumban megkapja, és ezeket az adatokat egy másik adatkezelőnek továbbítsa.

8.7 Tiltakozás joga

Az érintett jogosult arra, hogy a saját helyzetével kapcsolatos okokból bármikor tiltakozzon személyes adatainak közérdekű vagy az adatkezelőre ruházott közhatalmi jogosítvány gyakorlásának keretében végzett feladat végrehajtásához szükséges adatkezelés, vagy az adatkezelő vagy egy harmadik fél jogos érdekeinek érvényesítéséhez szükséges kezelése ellen, ideértve az említett rendelkezéseken alapuló profilalkotást is. Tiltakozás esetén az adatkezelő a személyes adatokat nem kezelheti tovább, kivéve, ha azt olyan kényszerítő erejű jogos okok indokolják, amelyek elsőbbséget élveznek az érintett érdekeivel, jogaival és szabadságaival szemben, vagy amelyek jogi igények előterjesztéséhez, érvényesítéséhez vagy védelméhez kapcsolódnak.

8.8 Automatizált döntéshozatal egyedi ügyekben, beleértve a profilalkotást

Az érintett jogosult arra, hogy ne terjedjen ki rá az olyan, kizárólag automatizált adatkezelésen alapuló döntés hatálya, amely rá nézve joghatással járna vagy őt hasonlóképpen jelentős mértékben érintené.

8.9 Visszavonás joga

Az érintett jogosult arra, hogy hozzájárulását bármikor visszavonja.

8.10 Bírósághoz fordulás joga

Az érintett a jogainak megsértése esetén az adatkezelő ellen bírósághoz fordulhat. A bíróság az ügyben soron kívül jár el.

8.11 Adatvédelmi hatósági eljárás

Panasszal a Nemzeti Adatvédelmi és Információszabadság Hatóságnál lehet élni:

Név: Nemzeti Adatvédelmi és Információszabadság Hatóság
Székhely: 1125 Budapest, Szilágyi Erzsébet fasor 22/C.
Levelezési cím: 1530 Budapest, Pf.: 5.
Telefon: 0613911400
Fax: 0613911410
E-mail: ugyfelszolgalat@naih.hu
Honlap: http://www.naih.hu

9. **Egyéb rendelkezések**

E tájékoztatóban fel nem sorolt adatkezelésekről az adat felvételekor adunk tájékoztatást.

Tájékoztatjuk ügyfeleinket, hogy a bíróság, az ügyész, a nyomozó hatóság, a szabálysértési hatóság, a közigazgatási hatóság, a Nemzeti Adatvédelmi és Információszabadság Hatóság, a Magyar Nemzeti Bank, illetőleg jogszabály felhatalmazása alapján más szervek tájékoztatás adása, adatok közlése, átadása, illetőleg iratok rendelkezésre bocsátása végett megkereshetik az adatkezelőt.

A Balaton Tánc Egyesület a hatóságok részére – amennyiben a hatóság a pontos célt és az adatok körét megjelölte – személyes adatot csak annyit és olyan mértékben ad ki, amely a megkeresés céljának megvalósításához elengedhetetlenül szükséges.

10. **Havi támogatás / ismétlődő bankkártyás fizetés (Barion)**

Kezelt adatok
• E‑mail‑cím
• Választott támogatási összeg
• Barion PaymentId és RecurrenceId
• Tranzakció – összeg, dátum, státusz
• IP‑cím, böngésző‑meta (Barion PSD2‑megfeleléshez)

Adatkezelés célja – a támogatási összeg rendszeres, automatikus beszedése és a könyvelési bizonylat kiállítása.

Jogalap
• GDPR 6. cikk (1) a) – az érintett önkéntes hozzájárulása (feliratkozási checkbox)
• GDPR 6. cikk (1) c) – számviteli kötelezettség (Számv. tv. 169 §)

Megőrzési idő – a támogatási jogviszony megszűnésétől számított 8 év.

Adatfeldolgozó
Barion Payment Zrt. (1117 Budapest, Infopark sétány 1., Cg. 01‑10‑048552, MNB engedély H‑EN‑I‑1064/2013).
A bankkártya‑adatok nem jutnak el a Balaton Tánc Egyesülethez.

Lemondás – az érintett bármikor megszüntetheti támogatását a „Lemondás” linkre kattintva (lásd 11. fejezet) vagy e‑mailben (info@balatonte.hu).

11. Lemondás / törlés menete

1. A visszaigazoló e‑mailben található Lemondás gombra kattintva az érintett egy egyedi, egyszer felhasználható URL‑re jut:https://balatonte.hu/api/cancel-subscription?email=XXX?token=XXXXXXXX
2. Az URL a Barion CancelRecurringPayment végpontját hívja, majd törli a támogatás rekordját az adatbázisból.
3. A rendszer „Az előfizetés törölve” üzenetet jelenít meg.
`;

export default privacyPolicy;